import React from 'react';
import { Box, SxProps } from '@mui/material';
import { Link } from '@tanstack/react-router';

const POLICY_URL = 'https://help.zscaler.com/legal/acceptable-use-policy';

const CopilotDisclaimer = ({ sx }: { sx?: SxProps }) => (
  <Box
    sx={{
      textAlign: 'center',
      alignSelf: 'center',
      textDecoration: 'underline',
      width: 'fit-content',
      fontSize: 12,
      color: theme => theme.palette.colors.neutrals[600],
      ':hover': { color: theme => theme.palette.colors.primary[500] },
      ...sx,
    }}
    component={Link}
    to={POLICY_URL}
    target="_blank">
    Acceptable Use Policy
  </Box>
);

export default CopilotDisclaimer;
